<select class="form-control" (change)="selectValue($event)">
    <option *ngIf="!hasValueSelected" value="" selected disabled>{{mensajeSeleccion}}</option>    
    <ng-container *ngFor="let option of options">         
        <option *ngIf="selectedValue == option.value" value="{{option.value}}" selected>{{option.label}}</option>
        <option *ngIf="selectedValue != option.value" value="{{option.value}}">{{option.label}}</option>        
    </ng-container>
</select>